"use client";
import { useIdentify } from "../hooks/use-identify";

export const IdentifyCustomer = () => {
    useIdentify();
    return null;
};
